module.exports = {
  you_have_been_challenged: '{playerName} has challenged you!',
  its_your_turn: "It's your turn in the game against {playerName}",
}
